<!-- <hr style="margin-top: 0px; margin-bottom: 0px;"> -->

<div *ngIf="eventsLoaded && sensorGroupsLoaded && associatedUserGroupsLoaded && userGroupsLoaded; else loading"
      class="col-sm-12">
  <p-confirmDialog #cd>
    <ng-template #footer>
      <button (click)="cd.onReject()" class="btn btn-basic" type="button">No</button>
      <button (click)="cd.onAccept()" class="btn btn-success" type="button">Yes</button>
      <div class="far fa-comment pull-right" style="color:#5279bc; cursor: pointer; font-size: 20px; margin-left: 20px; margin-top: 8px" aria-hidden="true" (click)="addNotes2ChangeLog('EventTrigger')"></div>
    </ng-template>
  </p-confirmDialog>

  <tabset *ngIf="screenInnerWidth >= 1000">
    <p-table #triggerTable 
      [columns]="selectedColumns" 
      [value]="eventsDisplayed" 
      sortField="name" 
      [scrollable]="true" 
      scrollHeight="flex"
      [resizableColumns]="true"
      columnResizeMode="expand"
      (onColResize)="onColumnResize($event)">
      
      <ng-template let-columns pTemplate="header">
        <tr>
          <th *ngFor="let col of columns" 
              pResizableColumn
              [ngStyle]="{'width': col.width}" 
              [pSortableColumn]="col.field" 
              style="background-color: var(--kig-section-header-bg); flex: none;" 
              [ngClass]="{'text-center': col.header == 'Enabled' || col.header == 'Eval' || col.header == 'Trigger' || col.header == 'Logs' || col.header == 'Copy' || col.header == 'Edit' || col.header == 'Del'}">
            <div *ngIf="col.field == 'checkbox'" (click)="toggleCheckedEventsDisplayed()" style="padding-left: 2px; font-size: 20px;">▣</div>
            <div *ngIf="col.field != 'checkbox'">{{col.header}}</div>
          </th>
        </tr>
      </ng-template>

      <ng-template let-columns="columns" let-rowData pTemplate="body">
        <tr>
          <td *ngFor="let col of columns" [ngStyle]="{'width': col.width}" style="flex: none; border-width: 0px; padding: 5px 5px 5px 12px; vertical-align: middle;">

            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'checkbox'">
                <div *ngIf="rowData.userFeatureAccess['EditThreshold']">
                  <p-checkbox [(ngModel)]="rowData.checked" binary="true" id="{{rowData.id}}" name="{{rowData.id}}" [ngModelOptions]="{standalone: true}" (ngModelChange)="eventCheckedChanged()" ></p-checkbox>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'name'">
                <div class="css-tooltip" [attr.tooltip-data]="rowData.id">
                  {{rowData.name}}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'currentValue'">
                <div class="text-center">
                  <div *ngIf="rowData.userFeatureAccess['EvaluateEvent']">
                    <button (click)="evaluateEvent(rowData, true, false, true)" class="btn" type="button" [ngStyle]="{'background-color': getEventConditionStatusColor(rowData)}"
                          style="width: 100%; height: 30px; border-radius: 20px; border: 1px solid lightgray; padding-top: 4px; background-color: var(--kig-section-header-bg); color: black; font-size: 13px;">
                        {{ getConditionEvalValue(rowData) }}
                    </button>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'conditionCount'">
                <div class="css-tooltip" [attr.tooltip-data]="rowData.tooltips['Threshold']" [ngStyle]="{'color': rowData.itemColor['Threshold']}">
                  <div *ngIf="rowData.userFeatureAccess['EditThreshold']" (click)="setupQuickEditThreshold(rowData)" style="cursor: pointer;">{{ getConditionForTable(rowData) }}</div>
                  <div *ngIf="!rowData.userFeatureAccess['EditThreshold']" >{{ getConditionForTable(rowData) }}</div>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'actionCount'">
                <a *ngIf="isSingleFloodIrrigationAction(rowData); else actionTextTpl"
                   (click)="openManualFloodFromLink(rowData.id)"
                   title="Open manual flood irrigation"
                   style="cursor: pointer; color: rgb(0, 123, 255); text-decoration: none;">{{ getActionForTable(rowData) }}</a>
                <ng-template #actionTextTpl>{{ getActionForTable(rowData) }}</ng-template>
              </ng-container>

              <ng-container *ngSwitchCase="'owner'">
                {{ getOwnerName(rowData) | slice:0:16 }}...
              </ng-container>

              <ng-container *ngSwitchCase="'modifiedDate'">
                {{ rowData.modifiedDate | date : 'medium'}}
              </ng-container>

              <ng-container *ngSwitchCase="'isDisabled'">
                <div class="css-tooltip text-center" [attr.tooltip-data]="rowData.tooltips['Enable']">
                  <div *ngIf="rowData.userFeatureAccess['EnableEvent']">
                      <button (click)="changeEventEnableState(rowData, !rowData.isDisabled)" class="btn btn-sm" style="color: black; width: 55px; height: 30px; border-radius: 20px; border: 1px solid lightgray; padding-top: 4px; font-weight: 500;"
                              [ngStyle]="{'background-color': rowData.isDisabledColor, 'color': rowData.itemColor['Enable']}" type="button">{{!rowData.isDisabled ? 'True' : 'False'}}</button>
                  </div>
                  <div *ngIf="!rowData.userFeatureAccess['EnableEvent']">
                    <button class="btn btn-sm" style="color: black; width: 55px; height: 30px; border-radius: 20px; border: 1px solid lightgray; padding-top: 4px; font-weight: 500;"
                              [ngStyle]="{'background-color': rowData.isDisabledColor, 'color': rowData.itemColor['Enable']}" type="button">{{!rowData.isDisabled ? 'True' : 'False'}}</button>
                  </div>
                </div>
              </ng-container>

            <ng-container *ngSwitchCase="'actionQueue'">
              <div *ngIf="rowData.actionQueueId > 0" class="text-center">
                <button (click)="openQueuedEventActions(rowData)" class="btn btn-sm" [ngStyle]="{'background-color': white}"
                          style="color: black; border-radius: 20px; border: 1px solid lightgray; padding-top: 4px; width: 100%; height: 30px;" type="button">{{ rowData.actionQueuePosition > 0 ? rowData.actionQueuePosition : '' }}</button>
              </div>
            </ng-container>

              <ng-container *ngSwitchCase="'triggerNow'">
                <div class="css-tooltip" [attr.tooltip-data]="rowData.tooltips['Triggered']">
                  <div *ngIf="rowData.userFeatureAccess['TriggerActions']" class="text-center">
                    <!-- // 0: No status, 1: Waiting for status, 2: Not busy, 3: Busy, 4: unknown -->
                    <div *ngIf="rowData.overallActionStatus.state == 1" class="fa fa-spinner fa-spin fa-1x fa-fw" style="color: black; font-size: 16px;"></div>
                    <div *ngIf="rowData.overallActionStatus.state == 2" (click)="invokeEvent(rowData)" aria-hidden="true" class="fas fa-redo-alt" [ngStyle]="{'color': rowData.itemColor['Triggered']}" style="color: black; cursor: pointer; font-size: 15px;"></div>
                    <div *ngIf="rowData.overallActionStatus.state == 3" (click)="stopEventAction(rowData)" class="fa-solid fa-stop" style="color: #c8102e; font-size: 16px; cursor: pointer;"></div>
                    <div *ngIf="rowData.overallActionStatus.state == 3" style="color: black; font-size: 12px;">{{ rowData.overallActionStatus.duration }}</div>                
                    <div *ngIf="rowData.overallActionStatus.state == 4" style="color: #c8102e; font-size: 16px;">?</div>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'miniChart'">
                  <mini-chart
                    [sensors]="rowData.miniChartData.sensors"
                    [sensorReadings]="rowData.miniChartData.sensorReadings"
                    [sensorReadingTypes]="rowData.miniChartData.sensorReadingTypes"
                    [currentEventName]="rowData.name">
                  </mini-chart>
              </ng-container>

              <ng-container *ngSwitchCase="'actionLog'">
                <button (click)="openLogs(rowData)" class="btn btn-sm" [ngStyle]="{'background-color': rowData.lastEventLogColor}"
                        style="color: black; border-radius: 20px; border: 1px solid lightgray; padding-top: 4px; width: 100%" type="button">Log</button>
              </ng-container>

              <ng-container *ngSwitchCase="'copy'">
                <div *ngIf="rowData.userFeatureAccess['CopyEvent']" class="text-center">
                  <div (click)="copyEvent(rowData)" aria-hidden="true" class="pi pi-copy" style="color:#1c4966; cursor: pointer; font-size: 14px;">
                  </div>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'edit'">
                <div class="text-center">
                  <div *ngIf="rowData.userFeatureAccess['EditEvent']" class="fas fa-pencil-alt"
                    (click)="editEvent(rowData)" aria-hidden="true"
                    style="color:#64a70b; cursor: pointer; font-size: 14px;">
                  </div>
                  <div *ngIf="rowData.userFeatureAccess['ViewEvent'] && !rowData.userFeatureAccess['EditEvent']"
                    (click)="editEvent(rowData)" aria-hidden="true" class="far fa-eye"
                    style="color:#1c4966; cursor: pointer; font-size: 14px;">
                  </div>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'delete'">
                <div *ngIf="rowData.userFeatureAccess['DeleteEvent']" class="text-center">
                  <div (click)="onDeleteConfirm(rowData)" aria-hidden="true" class="far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 14px;"></div>
                  <span class="sr-only">Delete</span>
                </div>
              </ng-container>

            </ng-container>
          </td>
        </tr>
      </ng-template>

      <ng-template let-columns pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="columns.length">
            No search results
          </td>
        </tr>
      </ng-template>

      <ng-template let-rowData pTemplate="caption">
        <div style="text-align: left; display: flex; gap: 10px; align-items: center; margin-bottom: 0px; flex-wrap: wrap;">
          
            <div style="display: block; width: 170px;">
              <label style="font-size: large; vertical-align: middle; color:black; font-weight: 500;">EVENTS & ACTIONS</label>
              <div style="display: flex; gap: 8px;" class="text-center">
                <div style="display: block;">
                  <div style="font-size: 12px;">Displayed</div>
                  <div style="font-size: 12px;">{{ eventsDisplayed.length }}</div>
                </div>
                <div style="display: block;">
                  <div style="font-size: 12px;">Selected</div>
                  <div (click)="showSelectedEvents()" style="font-size: 12px; cursor: pointer;">{{ eventsCheckedCount }}</div>
                </div>
                <div style="display: block;">
                  <div style="font-size: 12px;">Total</div>
                  <div style="font-size: 12px;">{{ events.length }}</div>
                </div>
              </div>
            </div>

          <div style="text-align: left; display: flex; gap: 10px; align-items: center;">
            <form (ngSubmit)="searchEventsTextChanged()">
                <i class="fa fa-search" style="margin:4px 4px 0 0; cursor: pointer;" (click)="searchEventsTextChanged()"></i>
                <i class="fa-solid fa-magnifying-glass-minus" style="margin:4px 4px 0 0; cursor: pointer;" (click)="clearSearchFilter()"></i>
                <input [(ngModel)]="eventSearchText" placeholder="Search" size="25" style="width:auto; height: 35px" type="text" name="eventSearchText" autocomplete="off"/>
            </form>
          </div>
          
          <button style="height: 35px; padding-top: 4px;" (click)="addEvent()" class="btn btn-success" type="button">Create</button>
          <button (click)="openGroupEventActions(groupChangeTemplate)" style="height: 35px; padding-top: 4px;" [disabled]="eventsCheckedCount < 1" class="btn btn-primary" type="button">Bulk Change</button>
          <button (click)="openEventLogsForSelectedEvents()" style="height: 35px; padding-top: 4px;" [disabled]="eventsCheckedCount < 1" class="btn btn-primary" type="button">Group Logs</button>
          <button style="height: 35px; padding-top: 4px;" (click)="refreshTableColorsValuesActionsTriggers()" class="btn btn-primary" type="button">Refresh Status</button>
          <!-- <button style="height: 35px; padding-top: 4px;" (click)="createEditActionQueue()" class="btn btn-primary" type="button">Action Queues</button> -->
          <span style="border: 1px dotted lightgray; width: 330px; height: 35px; padding-top: 5px; padding-left: 5px; color: #c8102e">{{updatedEventToDisplay}}</span>
          
          <ng-multiselect-dropdown
           
            [settings]="columnDropDownSettings"
            [data]="eventTableCols"
            [(ngModel)]="selectedColumns"
            (onSelect)="onColumnToggle()"
            (onSelectAll)="onColumnToggle()"
            (onDeSelect)="onColumnToggle()"
            (onDeSelectAll)="onColumnToggle()"
            style="min-width: 130px; height: 35px;">
          </ng-multiselect-dropdown>

          <button (click)="resetColumnsToDefault()" style="height: 35px; padding-top: 4px;" class="btn btn-primary" type="button">Reset Cols</button>

        </div> 
      </ng-template>
    </p-table>
  </tabset>


  <div *ngIf="screenInnerWidth < 1000" style="text-align: center; padding-top: 20px; padding-bottom: 20px;">
    <i class="fa fa-search" style="margin:4px 10px 0 0; cursor: pointer;" (click)="searchEventsTextChanged()"></i>
    <input [(ngModel)]="eventSearchText" placeholder="Search" size="25" style="width:auto; height: 35px" type="text" name="eventSearchText" autocomplete="off"/>
    <button style="margin-left: 10px; height: 35px; padding-top: 4px; margin-top: -2px;" type="button" class="btn btn-primary" (click)="searchEventsTextChanged()">Search</button>
    <button style="margin-left: 10px; height: 35px; padding-top: 4px; margin-top: -2px;" type="button" class="btn btn-primary" (click)="clearSearchFilter()">Clear</button>
    <button (click)="openScanModal(scanSensor)" class="btn btn-warning" style="margin-left: 10px; height: 35px; padding-top: 4px; margin-top: -2px;" type="button">Scan</button>
  </div>

  <div *ngIf="screenInnerWidth<1000" class="row card-group justify-content-center">
    <div *ngFor="let cEvent of eventsDisplayed; let index=index;" style="width: 325px;">
      <div class="card bg-light mb-3" style="max-width: 22rem; margin-right: 15px">
          <div class="card-header" style="background-color: var(--kig-section-header-bg); padding: 0.5rem">
              <h5 class="card-title" style="margin-bottom: 0rem;">
                  {{cEvent.name}}
              </h5>
          </div>
          <div class="card-body" style="padding: 0.3rem">
            <div *ngIf="cEvent.userFeatureAccess['EditThreshold']" (click)="setupQuickEditThreshold(cEvent)" style="cursor: pointer; text-align: center; padding: 10px">{{getConditionForTable(cEvent)}}</div>
            <div *ngIf="!cEvent.userFeatureAccess['EditThreshold']" style="text-align: center; padding: 10px">{{getConditionForTable(cEvent)}}</div>

            <table width="100%" style="border-collapse: collapse; border-spacing: 0;">
              <tr style="line-height: 35px;">
                <td width="25%" align="center" style="vertical-align: middle;">
                  <div *ngIf="cEvent.userFeatureAccess['EnableEvent']">
                    <button (click)="changeEventEnableState(cEvent, !cEvent.isDisabled)" class="btn btn-sm" style="color: black; border-color: darkgray;" [ngStyle]="{'background-color': cEvent.isDisabledColor}" type="button">{{!cEvent.isDisabled}}</button>
                  </div>
                </td>
                <td width="25%" align="center">
                  <div *ngIf="cEvent.eventType=='Sensor Based' && cEvent.userFeatureAccess['EvaluateEvent']">
                    <div (click)="evaluateEvent(cEvent, true, false, true)" aria-hidden="true" class="fas fa-clipboard-check" style="color:#1c4966; cursor: pointer; font-size: 22px; vertical-align: middle;"></div>
                  </div>
                  <div *ngIf="cEvent.eventType=='Timer Based' && cEvent.userFeatureAccess['EvaluateEvent']">
                    <div (click)="evaluateEvent(cEvent, true, false, true)" aria-hidden="true" class="fas fa-clipboard-check" style="color:#1c4966; cursor: pointer; font-size: 22px; vertical-align: middle;"></div>
                  </div>
                </td>
                <td width="25%" align="center">
                  <div *ngIf="cEvent.userFeatureAccess['TriggerActions']">
                    <div (click)="invokeEvent(cEvent)" aria-hidden="true" class="fas fa-redo-alt" style="color:#c8102e; cursor: pointer; font-size: 22px; vertical-align: middle;"></div>
                  </div>
                </td>
                <td width="25%" align="center">
                  <button (click)="openLogs(cEvent)" class="btn btn-sm" style="background-color: var(--kig-section-header-bg);color: black;" type="button">Logs</button>
                </td>
              </tr>
            </table>
          </div>
        </div>
    </div>
  </div>
</div>


<ng-template #loading>
  <div class="col-xs-4 col-lg-3">
    <i class="fa fa-spinner fa-spin fa-2x fa-fw" style="margin: 30px 10px 10px 30px;"></i>
    <span>Loading...</span>
  </div>
</ng-template>


<ng-template #scanSensor class="qrScanner" let-modal>
  <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content">
    <div style="background-color: #548235;  height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
      <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">QR Scanner</h5>
      <button
        (click)="scanModalRef.hide()"
        class="ms-auto fas fa-times"pe="button"
        style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
      </button>
    </div>

    <div class="modal-body qr-scanner-bodyEvent scanSensorEvent" style="padding: 0px;">
      <kig-scanner (scanSuccess)="scanComplete($event)" (camerasFound)="camerasFound($event)" [device]="selectedDevice" id="scanZX"></kig-scanner>

      <select (change)="onDeviceSelectChange($event.target.value)" style="height: 38px; width: 450px; margin-top: 15px;">
        <option value="" [selected]="!selectedDevice">No Device</option>
        <option *ngFor="let device of availableDevices"
            [value]="device.deviceId"
            [selected]="selectedDevice && device.deviceId === selectedDevice.deviceId">{{ device.label }}
        </option>
      </select>
    </div>

    <div style="display: flex; margin-bottom: 20px;">
      <input type="text" [(ngModel)]="scannedSensor" name="sensorUUID" style="width: 280px; height: 35px; margin-left: 20px; margin-top: 20px; margin-right: 20px;" autofocus />
      <button (click)="locateEventsAssociatedWithScannedSensor()" [disabled]="scannedSensor === ''" class="btn btn-success" id="acceptButton" type="button" style="height: 35px; margin-top: 20px; margin-bottom: 20px;">Locate</button>
  </div>
  </div>
</ng-template>


<ng-template #groupChangeTemplate>
  <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="groupChange-modal">
  <!-- <div class="modal-content groupChange-modal"> -->
      <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
          <h5 style="color: rgb(10, 10, 10); text-transform: none;">Bulk Change</h5>
          <button
              (click)="groupChangeModalRef.hide()"
              class="ms-auto fas fa-times"pe="button"
              style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
          </button>
        </div>
      <div class=" modal-body">
        <label for="ActionGroup" style="font-weight: 500; margin-bottom: 10px;">Select Action</label><br>

        <input type="radio" style="cursor: pointer;" [(ngModel)]="groupChangeAction" name="ActionGroup" value="ManualTrigger" />
        <label style="margin-left: 10px; margin-bottom: 18px;">Manually trigger event actions</label><br>

        <input type="radio" style="cursor: pointer;" [(ngModel)]="groupChangeAction" name="ActionGroup" value="DisableAll" />
        <label style="margin-left: 10px; margin-bottom: 6px;">Disable all events</label><br>

        <input type="radio" style="cursor: pointer;" [(ngModel)]="groupChangeAction" name="ActionGroup" value="EnableAll" />
        <label style="margin-left: 10px; margin-bottom: 18px;">Enable all events</label><br>

        <input type="radio" style="cursor: pointer;" [(ngModel)]="groupChangeAction" name="ActionGroup" value="Pause" [disabled]="false"/>
        <label style="margin-left: 10px; margin-bottom: 6px; margin-right: 10px;">Pause events for </label>
        <input type="number" [(ngModel)]="groupPauseValue" name="ActionGroupVal4" style="width: 60px;" />
        <label style="margin-left: 10px; margin-bottom: 6px;">minutes</label><br>

        <input type="radio" style="cursor: pointer;" [(ngModel)]="groupChangeAction" name="ActionGroup" value="Unpause" [disabled]="false"/>
        <label style="margin-left: 10px; margin-bottom: 18px;">Unpause events</label><br>

        <input type="radio" style="cursor: pointer;" [(ngModel)]="groupChangeAction" name="ActionGroup" value="ChangeThresholdBy" />
        <label style="margin-left: 10px; margin-right: 10px; margin-bottom: 6px;">Change threshold by</label>
        <input type="number" [(ngModel)]="groupThresholdChangeByValue" name="ActionGroupVal1" style="width: 80px;" /><br>

        <input type="radio" style="cursor: pointer;" [(ngModel)]="groupChangeAction" name="ActionGroup" value="SetThresoldTo" />
        <label style="margin-left: 10px; margin-right: 10px; margin-bottom: 18px;">Set threshold to</label>
        <input type="number" [(ngModel)]="groupThresholdSetToValue" name="ActionGroupVal3" style="width: 80px;" /><br>

        <div style="display: flex; align-items: center;">
          <input type="radio" style="cursor: pointer;" [(ngModel)]="groupChangeAction" name="ActionGroup" value="SetActionQueueTo" />
          <label style="margin-left: 10px; margin-right: 10px;">Set Action Queue to</label>
          <div style="width: 220px; height: 38px;">
            <ngx-select-dropdown name="owner" id="ActionGroupVal4" [config]="actionQueueGroupConfig" [options]="actionQueues" [(ngModel)]="groupActionQueueSetToValue"></ngx-select-dropdown><br>
          </div>
        </div>

        <div style="margin-top: 20px;">
          <div class="far fa-comment pull-right" style="color:#5279bc; cursor: pointer; font-size: 20px; margin-left: 20px; margin-top: 12px" aria-hidden="true" (click)="addNotes2ChangeLog('EventEditGroup')"></div>
            <button type="button" class="btn btn-success" (click)="executeGroupChange()" [disabled]="groupChangeAction == ''" style="float: right; margin-right: 1px; margin-bottom: 20px; margin-top: 3px">Execute</button>
            <button (click)="groupChangeModalRef.hide()" class="btn btn-basic pull-right" style="margin-right: 5px; margin-top: 3px;" type="button">Cancel</button>
        </div>
      </div>
  </div>
</ng-template>

